var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":_vm.path,"links":""},on:{"click":_vm.sidebarMini}},[_c('v-list-item-icon',[(_vm.icon)?_c('img',{staticClass:"icon-sidebar",attrs:{"src":_vm.iconPath(_vm.icon)}}):_vm._e()]),_c('v-list-item-content',[_c('v-list-item-title',[_c('strong',[_vm._v(_vm._s(_vm.title))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }